export default __webpack_public_path__ + "82609852adb721b08f8e496fa0df96a5.png";